import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useJsonApi } from '@/modules/api/hooks/useJsonApi';
import { queryKeys } from '@/modules/api/queryKeys';
import { JsonApiClient } from '@/modules/api/utils/createJsonApiClient';
import { constructMeta } from '@/modules/reactQuery/constructMeta';

import { getDemoNegotiationsResponseStruct } from '../helpers/getDemoNegotiationsResponseStruct';
import { parseGetDemoNegotiationsResponse } from '../helpers/parseGetDemoNegotiationsResponse';

export const useGetDemoNegotiationsQuery = () => {
  const jsonApi = useJsonApi();
  const { t } = useTranslation('apiMessages/useGetDemoNegotiationsQuery');

  return useQuery({
    queryKey: [queryKeys.customer.getDemoNegotiations],
    queryFn: getDemoNegotiations(jsonApi),
    meta: constructMeta({
      errorMessages: {
        401: {
          UNAUTHENTICATED: t('Your session has expired. Please sign in'),
        },
        403: {
          FORBIDDEN: t('You do not have access to see negotiations'),
        },
      },
    }),
  });
};

const getDemoNegotiations = (jsonApi: JsonApiClient) => {
  return async () => {
    const response = await jsonApi.getMany({
      path: '/customer/demo_negotiations',
      responseStruct: getDemoNegotiationsResponseStruct,
    });

    return parseGetDemoNegotiationsResponse(response);
  };
};
